<template>
  <div :class="{ 'enterprise-wechat-code': !isMobile }">
    <div :class="isMobile ? 'm-company-wx' : 'jc-company-wx'">
      <div :class="isMobile ? 'm-company-title' : 'mb-8px'">
        <h3 class="jc-company-wx-title">添加企业微信</h3>
        <h4 class="jc-company-wx-subTitle">获取1V1专业服务</h4>
      </div>
      <div>
        <img src="@/assets/img/wx.png" style="width: 120px; height: 120px" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EnterpriseWeChatCode'
}
</script>
<style scoped>
.enterprise-wechat-code {
  margin-right: 24px;
}
.mb-8px {
  margin-bottom: 8px;
}
.jc-company-wx {
  width: 150px;
  height: 208px;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  text-align: left;
  padding: 16px;
}
.jc-company-wx::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 0;
  width: calc(100% - 24px);
  height: 10px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.jc-company-wx-title {
  height: 28px;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  color: #e1251b;
}
.jc-company-wx-subTitle {
  line-height: 20px;
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
}
@media only screen and (max-width: 640px) {
  .m-company-wx {
    height: 144px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
    display: flex;
    padding: 12px;
    justify-content: space-between;
  }
  .m-company-title {
    align-self: center;
  }
  .jc-company-wx::after {
    box-shadow: none;
  }
}
</style>
